@use '../styles/tokens' as *;

.overlay {
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba($white, 0.7);
  @include text-13;
  color: $base-4;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid $blue-gray-7;
  border-top-color: $utility-blue;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
